import { IEtfService, EtfServiceImpl } from './etf.service';

export * from './etf.model';

export const EtfService: IEtfService = new EtfServiceImpl();